/** Which child is learning right now (kept in this browser). Sent as X-Learner on the learning API. */
const KEY = "jc.learner";
const subs = new Set<() => void>();
export const getLearnerId = (): string | null => { try { return localStorage.getItem(KEY); } catch { return null; } };
export function setLearnerId(id: string | null) {
  try { if (id) localStorage.setItem(KEY, id); else localStorage.removeItem(KEY); } catch { /* storage blocked: the choice lasts until reload */ }
  subs.forEach((f) => f());
}
export const onLearnerChange = (f: () => void) => { subs.add(f); return () => { subs.delete(f); }; };
/** localStorage key for per-child values on this device: unchanged for the account itself, suffixed per child. */
export const learnerKey = (base: string) => { const id = getLearnerId(); return id ? `${base}.${id}` : base; };
